import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import UserItem from './view.tsx';

export default ComponentWithAnalytics('deleteWatcherIcon', {
	onDeleteUser: 'clicked',
})(injectIntl(UserItem));
